import styled from 'styled-components'

export const SidebarWrapper = styled.div`
  position: relative;

  @media (max-width: 1024px) {
    position: fixed;
    top: calc(56px + 106px); /* header + property header height */
    left: 0;
    bottom: 0;
    z-index: 100;
  }
`

export const SidebarContainer = styled.nav<{ $isOpen: boolean }>`
  width: 200px;
  background: ${({ theme }) => theme.colors.background.primary};
  border-right: 1px solid ${({ theme }) => theme.colors.border.default};
  overflow-y: auto;
  overflow-x: hidden;
  flex-shrink: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
  height: 100%;
  transition: transform 0.3s ease;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 1024px) {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    transform: translateX(${(props) => (props.$isOpen ? '0' : '-100%')});
    box-shadow: ${({ theme, $isOpen }) =>
      $isOpen ? theme.shadows.md : 'none'};
  }
`

export const SidebarToggleButton = styled.button<{ $isOpen: boolean }>`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    position: fixed;
    left: ${(props) => (props.$isOpen ? '200px' : '0')};
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 72px;
    background: ${({ theme }) => theme.colors.background.primary};
    border: 1px solid ${({ theme }) => theme.colors.border.default};
    border-left: none;
    border-radius: 0 6px 6px 0;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 101;
    box-shadow: ${({ theme }) => theme.shadows.sm};

    &:hover {
      background: ${({ theme }) => theme.colors.background.secondary};
    }

    &:active {
      background: ${({ theme }) => theme.colors.background.tertiary};
    }
  }
`

export const MobileOverlay = styled.div<{ $isOpen: boolean }>`
  display: none;

  @media (max-width: 1024px) {
    display: ${(props) => (props.$isOpen ? 'block' : 'none')};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.colors.surface.overlay};
    z-index: 99;
  }
`

export const SidebarContent = styled.div`
  padding: 24px 0;
`

export const NavSection = styled.div`
  margin-bottom: 32px;

  &:first-of-type {
    margin-top: 8px;
  }
`

export const NavTitle = styled.h3`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.colors.text.tertiary};
  margin-bottom: 8px;
  padding: 0 24px;
`

export const NavItem = styled.a<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 24px;
  color: ${({ theme, $active }) =>
    $active ? theme.colors.primary : theme.colors.text.secondary};
  background: ${({ theme, $active }) =>
    $active ? theme.colors.primaryLight : 'transparent'};
  text-decoration: none;
  font-size: 13px;
  transition: all 0.2s;
  position: relative;
  cursor: pointer;

  &:hover {
    color: ${({ theme, $active }) =>
      $active ? theme.colors.primary : theme.colors.text.primary};
    background: ${({ theme, $active }) =>
      $active ? theme.colors.primaryLight : theme.colors.background.secondary};
  }

  ${(props) =>
    props.$active &&
    `
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 2px;
      background: ${props.theme.colors.primary};
    }
  `}
`

export const NavIcon = styled.span`
  margin-right: 8px;
  font-size: 16px;
`
